/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import plcLogo from '@/assets/ditto.png'

const handleStyleLeft = { left: -2 }

function DittoNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} style={handleStyleLeft} />

      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={plcLogo} alt="Ditto Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>Digital Twins</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default DittoNode
